import React from 'react';
import PropTypes from 'prop-types';
import ExternalLinkIcon from 'components/v2/icons/ExternalLinkIcon';

export default function ShipmentLink({ shipment }) {
  return (
    <a
      className="underline"
      href={`/shipments/${shipment?._id}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      <div className="flex items-center space-x-1">
        <span>{shipment?.shipment_id}</span>
        <ExternalLinkIcon className="w-4 h-4" />
      </div>
    </a>
  );
}

ShipmentLink.propTypes = {
  actionItem: PropTypes.shape({
    _id: PropTypes.string,
    shipment_id: PropTypes.string,
  }),
};

ShipmentLink.defaultProps = {
  actionItem: {},
};
